<div class="bg-color container">
  <app-header></app-header>
  <div class="row content-margin">
    <div class="side-menu">
      <app-sidemenu></app-sidemenu>
    </div>
    <div class="col middle-content">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
